module.exports = __webpack_public_path__ + "img/3m.c6c1933d.jpg";